export const theme = {
  colors: {
    bg: {
      mainBg: "#F8F8F8",
      whiteBg: "#ffffff",
      blue: "#4CE5B1",
      darkBlue: "#1da1d1",
      mainLightBg: "#F6F6F9",
      hoverBlue: "#E6FBF4",
    },
    text: {
      lightBlack: "#313949",
      black: "#000000",
      red: "red",
      blue: "#00B2F5",
      white: "#ffffff",
    },
    color: {
      blue: "#00B2F5",
      black: "#000000",
      lightBlack: "#333333",
      red: "red",
      lightGrey: "#EDF1FF",
    },
    border: {
      grey: "rgba(49, 57, 73, 0.1)",
      red: "red",
      lightBlack: "#ccc",
    },
    button: {
      blue: "#4CE5B1",
      red: "red",
      lightBlue: "#E6FBF4",
    },
  },
};
